import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Container,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  Divider,
  Avatar,
  Stack,
  Tooltip,
  TablePagination,
  Chip,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

import {
  Delete as DeleteIcon,
  Add as AddIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Close as CloseIcon,
  Badge as BadgeIcon,
} from '@mui/icons-material';
import { ErrorMessage, successMessage } from '../Message';
import { delete_Role, LoadRoles, newRole, updateRole } from '../BaseURL';


function Role() {


        const [roles, setRoles] = useState([]);
        const [searchTermRole, setSearchTermRole] = useState('');
        const [openDialog, setOpenDialog] = useState(false);
        const [editingRole, setEditingRole] = useState(null);
        const [viewMode, setViewMode] = useState('table'); // 'table' or 'card'
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(10);

        const PRIMARY = '#1A9B7F';
        const PRIMARY_DARK = '#157763';

        // Cheap deterministic palette so each role chip gets a stable hue.
        const ROLE_HUES = ['#1A9B7F', '#1976d2', '#7c3aed', '#dc2626', '#d97706', '#0891b2', '#0d9488', '#be185d'];
        const hueFor = (name) => {
          const s = String(name || '');
          let h = 0;
          for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
          return ROLE_HUES[h % ROLE_HUES.length];
        };
        const initialsOf = (name) =>
          String(name || '?')
            .split(/[\s_/-]+/)
            .filter(Boolean)
            .slice(0, 2)
            .map((p) => p[0].toUpperCase())
            .join('');
       
      
        const [formData, setFormData] = useState({name: ''});
        const filteredRoles = roles.filter(role =>
          role.role.toLowerCase().includes(searchTermRole.toLowerCase())
        
        );
      
        const handleOpenDialog = (role = null) => {
          if (role) {
            setEditingRole(role);
            setFormData({
              name: role.role,
             
            });
          } else {
            setEditingRole(null);
            setFormData({
              name: '',
             
            });
          }
          setOpenDialog(true);
        };
      
        const handleCloseDialog = () => {
          setOpenDialog(false);
          setEditingRole(null);
          setFormData({
            name: '',
            icon: '',
            accessLevel: '',
            responsibilities: ['']
          });
        };
      
    
        useEffect(()=>{
            loadRoles()
        },[])

     const loadRoles =async()=>{
  
       try {
              const response = await axios.get(LoadRoles);
              if (response.data.success) {
              
              setRoles(response.data.results); 
              
              }
              
          } catch (error) {
              await Swal.fire({
              title: 'Error',
              text: error.response?.data?.message || 'Failed to Load Data',
              icon: 'error'
              });
              
          }
  
    }

    
        const handleSubmit = async() => {
          if (!formData.name ) {
           ErrorMessage('Error' ,'No Role Information Found')
            return;
          }
      
         // const filteredResponsibilities = formData.responsibilities.filter(r => r.trim());

         const result = await Swal.fire({
            title: 'Confirm / Cancel',
            text: "Are You Sure You Want To Save Role Information ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes Confirm'
          });

          if (result.isConfirmed) {
            Swal.fire({
              title: 'Processing.......',
              text: 'Please wait',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });     
        
            
      
          if (editingRole) {
            
            
            try {
            
            const response = await axios.put(updateRole(editingRole.id), formData);
            
            if (response.data.success) {
    
            successMessage('Save',response.data.message)

            handleCloseDialog()
            loadRoles()
            
            }
                
            } catch (error) {

                await Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to Save',
                icon: 'error'
                });
            
                
            }

        } else {

        try {

 
       const response = await axios.post(newRole ,formData);
                
        if (response.data.success) {
                
        successMessage('Save',response.data.message)
        loadRoles()
         setFormData({
              name: '',
             
            });
      
        }
            
            } catch (error) {

               await Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to Save',
                icon: 'error'
                });
            }

            
 }
          }
      
          //handleCloseDialog();
        };
      
        const handleDeleteRole = async(roleId) => {
         

            const result = await Swal.fire({
            title: 'Confirm / Cancel',
            text: "Are you sure you want to delete this role?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes Confirm'
          });

          if (result.isConfirmed) {
            Swal.fire({
              title: 'Processing.......',
              text: 'Please wait',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });     
          Swal.fire({
            title: 'Processing...',
            text: 'Please wait',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });


           if (result.isConfirmed) {
            const response = await axios.delete(delete_Role(roleId));
            if (response.data.success) {
                 successMessage('Delete',response.data.message)
                 loadRoles()
                  setFormData({
              name: '',
             
            });
               
                }
              }

        }
        };
      
       
  const paginatedRoles = filteredRoles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      {/* Page heading */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2.5} flexWrap="wrap" gap={2}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box sx={{
            width: 42, height: 42, borderRadius: 1.75,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)`,
            color: 'white', boxShadow: `0 4px 12px ${alpha(PRIMARY, 0.35)}`,
          }}>
            <AdminPanelSettingsIcon />
          </Box>
          <Box>
            <Typography sx={{ fontSize: '1.35rem', fontWeight: 700, color: 'text.primary', lineHeight: 1.15 }}>
              Roles Management
            </Typography>
            <Typography sx={{ fontSize: '0.82rem', color: 'text.secondary', mt: 0.25 }}>
              Define the roles that drive permissions across the system.
            </Typography>
          </Box>
        </Stack>
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          onClick={() => handleOpenDialog()}
          sx={{
            textTransform: 'none', fontWeight: 700, borderRadius: 1.75, px: 2.25, py: 1,
            background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)`,
            boxShadow: `0 4px 12px ${alpha(PRIMARY, 0.28)}`,
            '&:hover': {
              background: `linear-gradient(135deg, ${PRIMARY_DARK} 0%, #126553 100%)`,
              boxShadow: `0 6px 16px ${alpha(PRIMARY, 0.40)}`,
            },
          }}
        >
          Add Role
        </Button>
      </Stack>

      {/* Stats strip */}
      <Stack direction="row" spacing={1.5} mb={2} flexWrap="wrap" useFlexGap>
        <Paper elevation={0} sx={{
          px: 2, py: 1.25, borderRadius: 1.75,
          border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper',
          display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 180,
        }}>
          <Box sx={{
            width: 32, height: 32, borderRadius: 1.5,
            bgcolor: alpha(PRIMARY, 0.18), color: PRIMARY,
            border: `1px solid ${alpha(PRIMARY, 0.30)}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <BadgeIcon sx={{ fontSize: 18 }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', color: 'text.secondary' }}>
              Total Roles
            </Typography>
            <Typography sx={{ fontSize: '1.15rem', fontWeight: 800, color: 'text.primary', lineHeight: 1.1 }}>
              {roles.length}
            </Typography>
          </Box>
        </Paper>
        {searchTermRole && (
          <Paper elevation={0} sx={{
            px: 2, py: 1.25, borderRadius: 1.75,
            border: '1px solid', borderColor: alpha('#1976d2', 0.30),
            bgcolor: alpha('#1976d2', 0.10),
            display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 180,
          }}>
            <Box sx={{
              width: 32, height: 32, borderRadius: 1.5,
              bgcolor: alpha('#1976d2', 0.20), color: '#60a5fa',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <SearchIcon sx={{ fontSize: 18 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', color: 'text.secondary' }}>
                Matching
              </Typography>
              <Typography sx={{ fontSize: '1.15rem', fontWeight: 800, color: 'text.primary', lineHeight: 1.1 }}>
                {filteredRoles.length}
              </Typography>
            </Box>
          </Paper>
        )}
      </Stack>

      {/* Roles table card */}
      <Paper elevation={0} sx={{
        borderRadius: 2, border: '1px solid', borderColor: 'divider',
        bgcolor: 'background.paper', overflow: 'hidden',
      }}>
        {/* Search bar inside the card header */}
        <Box sx={{
          px: 2, py: 1.5,
          borderBottom: '1px solid', borderColor: 'divider',
          display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
        }}>
          <Box sx={{
            width: 4, height: 22, borderRadius: 0.5,
            background: `linear-gradient(180deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)`,
          }} />
          <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: 'text.primary' }}>
            All Roles
          </Typography>
          <Box sx={{ flex: 1 }} />
          <TextField
            size="small"
            placeholder="Search roles…"
            value={searchTermRole}
            onChange={(e) => { setSearchTermRole(e.target.value); setPage(0); }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                </InputAdornment>
              ),
            }}
            sx={{
              width: { xs: '100%', sm: 280 },
              '& .MuiOutlinedInput-root': { borderRadius: 1.75, fontSize: '0.85rem', bgcolor: 'background.paper' },
            }}
          />
        </Box>

        <TableContainer>
          <Table size="small" sx={{
            '& .MuiTableCell-root': { py: 1, fontSize: '0.85rem', borderColor: 'divider' },
            '& .MuiTableCell-head': {
              py: 1.25, fontSize: '0.7rem', fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '0.6px',
              color: 'text.secondary', bgcolor: 'action.hover',
              borderBottom: '1px solid', borderColor: 'divider',
            },
          }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: 48 }}>#</TableCell>
                <TableCell>Role</TableCell>
                <TableCell sx={{ width: 120 }} align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRoles.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} sx={{ py: 6, textAlign: 'center', borderBottom: 'none' }}>
                    <AdminPanelSettingsIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
                    <Typography sx={{ color: 'text.secondary', fontSize: '0.9rem' }}>
                      {searchTermRole ? `No roles match "${searchTermRole}"` : 'No roles configured yet. Click "Add Role" to create one.'}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : paginatedRoles.map((role, idx) => {
                const hue = hueFor(role.role);
                const rowNumber = page * rowsPerPage + idx + 1;
                return (
                  <TableRow
                    key={role.id}
                    hover
                    sx={{ transition: 'background-color .15s ease', '&:hover': { bgcolor: alpha(PRIMARY, 0.04) } }}
                  >
                    <TableCell sx={{ color: 'text.secondary', fontWeight: 600 }}>
                      {String(rowNumber).padStart(2, '0')}
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Avatar sx={{
                          width: 34, height: 34, fontSize: 13, fontWeight: 800,
                          bgcolor: alpha(hue, 0.18), color: hue,
                          border: `1px solid ${alpha(hue, 0.32)}`,
                        }}>
                          {initialsOf(role.role)}
                        </Avatar>
                        <Box>
                          <Typography sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem', lineHeight: 1.2 }}>
                            {role.role}
                          </Typography>
                          <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>
                            Role ID: {role.id}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>
                    <TableCell align="right">
                      <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                        <Tooltip title="Edit role" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDialog(role)}
                            sx={{
                              color: '#60a5fa',
                              bgcolor: alpha('#1976d2', 0.12),
                              '&:hover': { bgcolor: alpha('#1976d2', 0.22) },
                            }}
                          >
                            <EditIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete role" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteRole(role.id)}
                            sx={{
                              color: '#f87171',
                              bgcolor: alpha('#dc2626', 0.12),
                              '&:hover': { bgcolor: alpha('#dc2626', 0.22) },
                            }}
                          >
                            <DeleteIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredRoles.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(_, p) => setPage(p)}
          onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          sx={{ borderTop: '1px solid', borderColor: 'divider', '& .MuiTablePagination-toolbar': { minHeight: 44 } }}
        />
      </Paper>

      {/* Add/Edit Role Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box sx={{
            background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)`,
            px: 3, py: 2.25, color: 'white',
            display: 'flex', alignItems: 'center', gap: 2,
          }}>
            <Box sx={{
              width: 42, height: 42, borderRadius: 1.75,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              bgcolor: 'rgba(255,255,255,0.18)',
              border: '1px solid rgba(255,255,255,0.28)',
            }}>
              <AdminPanelSettingsIcon />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{
                fontSize: '0.66rem', fontWeight: 700, letterSpacing: '1.4px',
                textTransform: 'uppercase', opacity: 0.85, lineHeight: 1,
              }}>
                User Role
              </Typography>
              <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, mt: 0.4, lineHeight: 1.2 }}>
                {editingRole ? 'Edit Role' : 'Add New Role'}
              </Typography>
            </Box>
            <IconButton
              onClick={handleCloseDialog}
              sx={{
                color: 'white', bgcolor: 'rgba(255,255,255,0.12)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.22)' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ bgcolor: 'action.hover', p: 3 }}>
          <Paper elevation={0} sx={{
            p: 2.5, borderRadius: 2,
            border: '1px solid', borderColor: 'divider',
            bgcolor: 'background.paper',
          }}>
            <Typography sx={{
              fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px',
              textTransform: 'uppercase', color: 'text.secondary', mb: 1.25,
            }}>
              Role Details
            </Typography>
            <TextField
              fullWidth
              size="small"
              label="Role Name *"
              value={formData.name}
              onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
              placeholder="e.g., Doctor, Cashier, Lab Technician"
              autoFocus
            />
            <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', mt: 1.25 }}>
              The role name appears in user assignments, permissions, and audit logs.
            </Typography>
          </Paper>
        </DialogContent>

        <DialogActions sx={{
          px: 3, py: 2,
          borderTop: '1px solid', borderColor: 'divider',
          bgcolor: 'background.paper',
          gap: 1,
        }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: '0.78rem', color: 'text.secondary' }}>
              {formData.name?.trim() ? 'Ready to save.' : 'Enter a role name to continue.'}
            </Typography>
          </Box>
          <Button
            onClick={handleCloseDialog}
            startIcon={<CancelIcon />}
            sx={{ textTransform: 'none', fontWeight: 600, color: 'text.secondary' }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            startIcon={<SaveIcon />}
            disabled={!formData.name?.trim()}
            sx={{
              textTransform: 'none', fontWeight: 700, px: 2.5, borderRadius: 1.75,
              background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)`,
              boxShadow: `0 4px 12px ${alpha(PRIMARY, 0.32)}`,
              '&:hover': {
                background: `linear-gradient(135deg, ${PRIMARY_DARK} 0%, #126553 100%)`,
                boxShadow: `0 6px 16px ${alpha(PRIMARY, 0.4)}`,
              },
              '&.Mui-disabled': { background: 'rgba(255,255,255,0.08)' },
            }}
          >
            {editingRole ? 'Update Role' : 'Add Role'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default Role